export const allPostsState$ = (state) => state.posts.allPosts;

export const totalPostsState$ = (state) => state.posts.totalPosts;

export const postsLatestState$ = (state) => state.posts.latest;

export const postDetailState$ = (state) => state.posts.detail;

export const postsHighLightState$ = (state) => state.posts.highLight;

export const postsPromotionCodeState$ = (state) => state.posts.promotionCodes;

export const postsApplicationState$ = (state) => state.posts.applications;

export const postsRelatedState$ = (state) => state.posts.related;

export const isLoadingState$ = (state) => state.global.isLoading;

export const isLoadingDetailState$ = (state) => state.posts.isLoadingDetail;

export const currentPageState$ = (state) => state.auth.currentPage;

export const dataCrawlState$ = (state) => state.posts.dataCrawl;

export const globalState$ = (state) => state.global;

export const notificationMessageState$ = (state) => state.global.noticationMessage;